const __default__ = {
  props: {
    menuData: {
      type: Object,
      default: null
    },
    checkedId: {
      type: [String, Number],
      default: ''
    },
    isLast: {
      type: Boolean,
      default: false
    },
    containerWidth: {
      type: Number,
      default: 780
    },
    containerPercent: {
      // 优先级高
      type: Number,
      default: null
    },
    color: {
      type: String,
      default: '#194189'
    },
    backColor: {
      type: String,
      default: '#1941891a'
    }
  },

  data() {
    return {
      menuList: [],
      expandStatus: 0,
      contentWidth: 0,
      visibleItems: [],
      allItemsWidth: 0,
      effectiveContainerWidth: 0 // 实际使用的容器宽度

    };
  },

  computed: {
    showExpandBtn: function () {
      return this.allItemsWidth > this.effectiveContainerWidth;
    }
  },
  methods: {
    checkedChange(e) {
      this.$emit('checkedChange', e);
    },

    expand() {
      this.expandStatus = this.expandStatus === 0 ? 1 : 0;
      this.updateVisibleItems();
    },

    updateVisibleItems() {
      if (this.expandStatus === 1) {
        this.menuList = [...this.menuData.content];
      } else {
        let currentWidth = 0;
        const visibleItems = [];

        for (let i = 0; i < this.menuData.content.length; i++) {
          const item = this.menuData.content[i];
          const itemWidth = this.getItemWidth(i);

          if (currentWidth + itemWidth > this.effectiveContainerWidth) {
            break;
          }

          visibleItems.push(item);
          currentWidth += itemWidth;
        }

        this.menuList = visibleItems;
      }
    },

    getItemWidth(index) {
      if (!this.$refs.tabListRef || !this.$refs.tabListRef.children || !this.$refs.tabListRef.children[index]) {
        return 0;
      }

      return this.$refs.tabListRef.children[index].offsetWidth;
    },

    calculateContentWidth() {
      if (!this.menuData || !this.menuData.content || this.menuData.content.length === 0) {
        this.contentWidth = 0;
        this.allItemsWidth = 0;
        return;
      } // 计算实际容器宽度


      this.calculateEffectiveContainerWidth();
      this.menuList = [...this.menuData.content];
      this.$nextTick(() => {
        if (!this.$refs.tabListRef) return; // 计算所有项目的总宽度

        this.allItemsWidth = Array.from(this.$refs.tabListRef.children).reduce((total, child) => total + child.offsetWidth, 0); // 更新可见项目

        this.updateVisibleItems();
      });
    },

    calculateEffectiveContainerWidth() {
      if (this.containerPercent !== null && this.containerPercent > 0 && this.$refs.containerRef) {
        const parentWidth = this.$refs.containerRef.parentElement.offsetWidth;
        this.effectiveContainerWidth = parentWidth * (this.containerPercent / 100);
      } else {
        this.effectiveContainerWidth = this.containerWidth;
      }
    }

  },

  mounted() {
    this.calculateContentWidth(); // 监听窗口大小变化，重新计算

    window.addEventListener('resize', this.calculateContentWidth);
  },

  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.calculateContentWidth);
  },

  watch: {
    menuData: {
      handler() {
        this.calculateContentWidth();
      },

      deep: true
    },

    containerWidth() {
      this.calculateContentWidth();
    },

    containerPercent() {
      this.calculateContentWidth();
    }

  }
};
import { useCssVars as _useCssVars } from 'vue';

const __injectCSSVars__ = () => {
  _useCssVars(_ctx => ({
    "13b748c6": _ctx.backColor,
    "7096da6d": _ctx.color
  }));
};

const __setup__ = __default__.setup;
__default__.setup = __setup__ ? (props, ctx) => {
  __injectCSSVars__();

  return __setup__(props, ctx);
} : __injectCSSVars__;
export default __default__;